import { createAction, props } from '@ngrx/store';

import { NutrientCategory } from '../shared/models';

export const loadNutrientCategoriesSuccess = createAction(
  '[App] load nutrient categories success',
  props<{ nutrientCategories: NutrientCategory[] }>(),
);
